import AbstractProvider from './AbstractProvider'

export default class SoundCloudProvider extends AbstractProvider {

    constructor(media) {
        super(media)
    }

    init(embedId) {
        return this.initPlayer(SC.Widget(embedId))
    }

    script() {
        return 'https://w.soundcloud.com/player/api.js'
    }

    setEmbedCode() {
        this.oembed('https://soundcloud.com/oembed')
    }

    ready() {
        return typeof SC !== 'undefined' && this.media.embed.length > 0
    }

    pause() {
        try {
            this.player.pause()
        } catch (e) {
            // Ignore, it'll be ok
        }
    }

}